import { BaseApiClient } from "./BaseApiClient";
export const BREEDS_ENDPOINT = {
    GET: "/Breeds"
};
/**
 * BreedsApiClient - client for fetching Breeds from BFF endpoints
 * @export
 * @class BreedsApiClient
 * @extends {BaseApiClient}
 */
export class BreedsApiClient extends BaseApiClient {
    /**
     * Fetch breeds from BFF
     * @throws {RequiredError}
     * @memberof BreedsApiClient
     */
    getBreeds() {
        let fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(BREEDS_ENDPOINT.GET, fetchOptions);
    }
}
//# sourceMappingURL=BreedsApiClient.js.map